<div>
  <div>
    <ccwb-heading size="m">{{ 'error.major.resolveVehicleHeal.headline' | translate }}</ccwb-heading>
    <ccwb-text
      class="cc-error__text"
      [innerHtml]="'error.major.resolveVehicleHeal.description' | translate | stripHtml | nl2br | bypassHtmlSecurity"
      size="l"
      tag="p"
    />

    <br />
  </div>

  <div class="cc-inline-notification" *ngIf="healingFailed$ | async">
    <ccwb-notification hide-dismiss-button icon="alert-circle" variant="error">
      <ng-container *ngTemplateOutlet="notificationContentFailure" />
    </ccwb-notification>
  </div>

  <div class="cc-error-actions">
    <ccwb-button
      [ccTrackClickOnce]="trackingData.secondaryOption"
      (click)="startNewConfiguration()"
      variant="secondary"
      size="s"
      theme="dark"
    >
      {{ 'error.major.resolveVehicleHeal.secondaryAction' | translate }}
    </ccwb-button>

    <ccwb-button
      [ccTrackClickOnce]="trackingData.primaryOption"
      [disabled]="healingFailed$ | async"
      (click)="restoreConfiguration()"
      variant="primary"
      size="s"
      theme="dark"
    >
      {{ 'error.major.resolveVehicleHeal.primaryAction' | translate }}
    </ccwb-button>
  </div>
</div>

<ng-template #notificationContentFailure>
  <p
    [innerHtml]="'error.major.resolveVehicleHeal.failure.message' | translate | stripHtml | nl2br | bypassHtmlSecurity"
  ></p>
</ng-template>

<ng-template #notificationContentSuccess>
  <p
    [innerHtml]="'error.major.resolveVehicleHeal.success.message' | translate | stripHtml | nl2br | bypassHtmlSecurity"
  ></p>
</ng-template>

<ng-template #notificationContentDifferences>
  <p
    [innerHtml]="
      'error.major.resolveVehicleHeal.differences.message' | translate | stripHtml | nl2br | bypassHtmlSecurity
    "
  ></p>
</ng-template>

<ng-template #notificationFooterDifferences>
  <div class="cc-error-actions">
    <ccwb-button
      class="cc-notification-button"
      [ccTrackClickOnce]="trackingData.secondaryOption"
      (click)="startNewConfiguration()"
      variant="secondary"
      size="s"
      theme="dark"
    >
      {{ 'error.major.resolveVehicleHeal.differences.secondaryAction' | translate }}
    </ccwb-button>
    <ccwb-button
      class="cc-notification-button"
      [ccTrackClickOnce]="trackingData.primaryOption"
      (click)="continueConfiguration()"
      variant="primary"
      size="s"
      theme="dark"
    >
      {{ 'error.major.resolveVehicleHeal.differences.primaryAction' | translate }}
    </ccwb-button>
  </div>
</ng-template>

<ng-template #notificationContentInitial>
  <p
    [innerHtml]="'error.major.resolveVehicleHeal.initial.message' | translate | stripHtml | nl2br | bypassHtmlSecurity"
  ></p>
</ng-template>

<ng-template #notificationFooterInitial>
  <div class="cc-error-actions">
    <ccwb-button
      class="cc-notification-button"
      [ccTrackClickOnce]="trackingData.secondaryOption"
      (click)="startNewConfiguration()"
      variant="secondary"
      size="s"
      theme="dark"
    >
      {{ 'error.major.resolveVehicleHeal.initial.secondaryAction' | translate }}
    </ccwb-button>
    <ccwb-button
      class="cc-notification-button"
      [ccTrackClickOnce]="trackingData.primaryOption"
      (click)="continueConfiguration()"
      variant="primary"
      size="s"
      theme="dark"
    >
      {{ 'error.major.resolveVehicleHeal.initial.primaryAction' | translate }}
    </ccwb-button>
  </div>
</ng-template>
